import { render, staticRenderFns } from "./TakeDelivery.vue?vue&type=template&id=86785cce&scoped=true"
import script from "./TakeDelivery.vue?vue&type=script&lang=js"
export * from "./TakeDelivery.vue?vue&type=script&lang=js"
import style0 from "./TakeDelivery.vue?vue&type=style&index=0&id=86785cce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86785cce",
  null
  
)

export default component.exports